module.exports = __webpack_public_path__ + "img/vertical_3_6_9016.9e09180f.png";